const Contenido3 = () => {
    return (
        <>
            <h1>Contenido 3</h1>
            <h3>Tercer Apartado</h3>
        </>
    )
}

export default Contenido3